(function () {
  function normalizeTag(value) {
    return (value || '').trim().toLowerCase();
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function initCollectionFilter(root) {
    var grid = root.querySelector('[data-mt-collection-grid]');
    var emptyEl = root.querySelector('[data-mt-collection-empty]');
    var countEls = root.querySelectorAll('[data-mt-product-count]');
    var filterButtons = root.querySelectorAll('[data-mt-filter-btn]');
    var sortSelectDesktop = root.querySelector('[data-mt-sort-select]');
    var sortSelectMobile = root.querySelector('[data-mt-sort-select-mobile]');
    var cards = Array.from(root.querySelectorAll('[data-product-card]'));

    if (!grid || !cards.length) return null;

    var state = {
      filterTag: '',
      sortBy: sortSelectDesktop ? sortSelectDesktop.value : 'manual',
      pendingFilterTag: '',
      pendingSortBy: 'manual',
      visibleCards: cards.slice()
    };

    function getSortSelects() {
      return [sortSelectDesktop, sortSelectMobile].filter(Boolean);
    }

    function syncSortSelects(value) {
      getSortSelects().forEach(function (select) {
        select.value = value;
      });
    }

    function updateCount() {
      var count = state.visibleCards.length;
      countEls.forEach(function (el) {
        var template = el.getAttribute('data-count-template') || '__COUNT__ products';
        el.textContent = template.replace('__COUNT__', String(count));
      });
    }

    function cardMatches(card, filterTag) {
      if (!filterTag) return true;
      var tags = (card.getAttribute('data-tags') || '').split('|').filter(Boolean);
      return tags.indexOf(filterTag) !== -1;
    }

    function sortCards(list) {
      var sorted = list.slice();

      sorted.sort(function (a, b) {
        if (state.sortBy === 'price-ascending') {
          return parseInt(a.getAttribute('data-price'), 10) - parseInt(b.getAttribute('data-price'), 10);
        }
        if (state.sortBy === 'price-descending') {
          return parseInt(b.getAttribute('data-price'), 10) - parseInt(a.getAttribute('data-price'), 10);
        }
        if (state.sortBy === 'title-ascending') {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        }
        return parseInt(a.getAttribute('data-index'), 10) - parseInt(b.getAttribute('data-index'), 10);
      });

      return sorted;
    }

    function setActiveFilterButton(filterTag) {
      filterButtons.forEach(function (btn) {
        var btnTag = normalizeTag(btn.getAttribute('data-filter'));
        var isActive = btnTag === filterTag;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function syncUrl() {
      var url = new URL(window.location.href);
      if (state.filterTag) {
        url.searchParams.set('filter', state.filterTag);
      } else {
        url.searchParams.delete('filter');
      }
      if (state.sortBy && state.sortBy !== 'manual') {
        url.searchParams.set('sort', state.sortBy);
      } else {
        url.searchParams.delete('sort');
      }
      window.history.replaceState({}, '', url);
    }

    function render() {
      cards.forEach(function (card) {
        card.hidden = true;
      });

      if (state.visibleCards.length === 0) {
        if (emptyEl) emptyEl.hidden = false;
        updateCount();
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      state.visibleCards.forEach(function (card) {
        card.hidden = false;
        grid.appendChild(card);
      });

      updateCount();
    }

    function applyFilter(filterTag, options) {
      options = options || {};
      state.filterTag = filterTag;
      state.pendingFilterTag = filterTag;
      var matched = cards.filter(function (card) {
        return cardMatches(card, filterTag);
      });
      state.visibleCards = sortCards(matched);
      setActiveFilterButton(filterTag);
      render();
      if (options.updateUrl !== false) {
        syncUrl();
      }
    }

    function applySort(sortBy, options) {
      options = options || {};
      state.sortBy = sortBy;
      state.pendingSortBy = sortBy;
      syncSortSelects(sortBy);
      var matched = cards.filter(function (card) {
        return cardMatches(card, state.filterTag);
      });
      state.visibleCards = sortCards(matched);
      render();
      if (options.updateUrl !== false) {
        syncUrl();
      }
    }

    function resetPendingFromState() {
      state.pendingFilterTag = state.filterTag;
      state.pendingSortBy = state.sortBy;
      setActiveFilterButton(state.pendingFilterTag);
      syncSortSelects(state.pendingSortBy);
    }

    function setPendingFilter(filterTag) {
      state.pendingFilterTag = filterTag;
      setActiveFilterButton(filterTag);
    }

    function setPendingSort(sortBy) {
      state.pendingSortBy = sortBy;
      syncSortSelects(sortBy);
    }

    function applyPending() {
      state.filterTag = state.pendingFilterTag;
      state.sortBy = state.pendingSortBy;
      syncSortSelects(state.sortBy);
      var matched = cards.filter(function (card) {
        return cardMatches(card, state.filterTag);
      });
      state.visibleCards = sortCards(matched);
      setActiveFilterButton(state.filterTag);
      render();
      syncUrl();
    }

    function clearPending() {
      state.pendingFilterTag = '';
      state.pendingSortBy = 'manual';
      setActiveFilterButton('');
      syncSortSelects('manual');
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = normalizeTag(btn.getAttribute('data-filter'));
        if (isMobileView()) {
          setPendingFilter(tag);
          return;
        }
        applyFilter(tag);
      });
    });

    getSortSelects().forEach(function (select) {
      select.addEventListener('change', function () {
        if (isMobileView()) {
          setPendingSort(select.value);
          getSortSelects().forEach(function (other) {
            if (other !== select) {
              other.value = select.value;
            }
          });
          return;
        }
        applySort(select.value);
      });
    });

    var urlParams = new URLSearchParams(window.location.search);
    var urlTag = normalizeTag(urlParams.get('filter'));
    var urlSort = urlParams.get('sort') || 'manual';
    var hasMatchingButton = false;

    filterButtons.forEach(function (btn) {
      if (normalizeTag(btn.getAttribute('data-filter')) === urlTag) {
        hasMatchingButton = true;
      }
    });

    if (urlTag && !hasMatchingButton) {
      urlTag = '';
    }

    var hasSortOption = getSortSelects().some(function (select) {
      return Array.from(select.options).some(function (option) {
        return option.value === urlSort;
      });
    });

    if (hasSortOption) {
      state.sortBy = urlSort;
      state.pendingSortBy = urlSort;
      syncSortSelects(urlSort);
    }

    applyFilter(urlTag, { updateUrl: false });

    return {
      resetPendingFromState: resetPendingFromState,
      applyPending: applyPending,
      clearPending: clearPending
    };
  }

  function initMobileDrawer(root, filterApi) {
    var toggle = root.querySelector('[data-mt-collection-filter-toggle]');
    var drawer = root.querySelector('[data-mt-collection-filter-drawer]');
    var closeTriggers = root.querySelectorAll('[data-mt-collection-filter-close]');
    var applyBtn = root.querySelector('[data-mt-apply]');
    var removeAllBtn = root.querySelector('[data-mt-remove-all]');
    var mobileQuery = window.matchMedia('(max-width: 989px)');

    if (!toggle || !drawer) return;

    function isMobile() {
      return mobileQuery.matches;
    }

    function openDrawer() {
      if (filterApi) {
        filterApi.resetPendingFromState();
      }
      drawer.classList.add('is-open');
      document.body.classList.add('mt-collection-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('mt-collection-filter-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (filterApi) {
        filterApi.resetPendingFromState();
      }
    }

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer();
      });
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        if (filterApi) {
          filterApi.applyPending();
        }
        closeDrawer();
      });
    }

    if (removeAllBtn) {
      removeAllBtn.addEventListener('click', function () {
        if (filterApi) {
          filterApi.clearPending();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    mobileQuery.addEventListener('change', function () {
      if (!isMobile()) {
        closeDrawer();
      }
    });
  }

  document.querySelectorAll('[data-mt-collection-filter]').forEach(function (root) {
    var filterApi = initCollectionFilter(root);
    initMobileDrawer(root, filterApi);
  });
})();
